// src/Pages/Landing/JoyrideKouvolaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideKouvolaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Kouvola"
      maakunta="Kymenlaakso"
      nearbyAreas={[
        "Kotka",
        "Hamina",
        "Iitti",
        "Pyhtää",
        "Miehikkälä",
        "Virolahti"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Kouvolassa ja Kymenlaakson alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Kouvola sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Kouvolan keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}